const defaultActiveYearsTo = new Date().getFullYear();
const defaultActiveYearsFrom = defaultActiveYearsTo - 3;

export class ActiveYearsModel {
  constructor(private readonly years: number[]) {}

  getMinYear = (): number => this.years.at(0) ?? defaultActiveYearsFrom;
  getMaxYear = (): number => this.years.at(-1) ?? defaultActiveYearsTo;
}
